module.exports = __webpack_public_path__ + "img/target_red_blue_arrow_72.87cd4101.png";